export default __webpack_public_path__ + "static/media/white_pawn.3fc55a69.png";